import { render, staticRenderFns } from "./AssetsAndProducts.vue?vue&type=template&id=e3777036&scoped=true&"
import script from "./AssetsAndProducts.vue?vue&type=script&lang=js&"
export * from "./AssetsAndProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3777036",
  null
  
)

export default component.exports